import jsPDF from "jspdf";
import { logoBase64 } from "../../../public/assets/logoBase64";
import { PolicyRenewalResponse } from "../interfaces/micartera.interfaces";

interface Params {
  data: PolicyRenewalResponse[];
  lob?: number;
  slob?: number;
  fecha1: Date;
  fecha2: Date;
  user: string;
}


export const exportarRenovaciones = ({ data, fecha1, fecha2, lob, slob, user }: Params) => {
  const doc = new jsPDF({ orientation: "landscape" }) as any;
  const currentY = 15;

  let fecha1Format = new Date(
    fecha1.setDate(fecha1.getDate() + 1)
  ).toLocaleString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  let fecha2Format = new Date(
    fecha2.setDate(fecha2.getDate() + 1)
  ).toLocaleString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });

  const pageHeader = (doc: jsPDF) => {
    doc.addImage(logoBase64, "PNG", 10, 10, 40, 13);

    doc.setFontSize(16);
    doc.text("Renovaciones - Plataforma Intermediario", 55, currentY);
    doc.setFontSize(12);
    doc.text(`${user}`, 55, currentY + 5);

    doc.setFontSize(11);
    // Fecha Desde
    doc.setFont(undefined!, "bold");
    doc.text(`Desde:`, 10, currentY + 15);

    doc.setFont(undefined!, "normal");
    doc.text(`${fecha1Format}`, 35, currentY + 15);

    // Fecha Hasta
    doc.setFont(undefined!, "bold");
    doc.text(`Hasta:`, 65, currentY + 15);

    doc.setFont(undefined!, "normal");
    doc.text(`${fecha2Format}`, 90, currentY + 15);

    // Ramo
    doc.setFont(undefined!, "bold");
    doc.text(`Ramo:`, 10, currentY + 20);
    doc.setFont(undefined!, "normal");
    doc.text(`${lob ? lob : 'Todos'}`, 35, currentY + 20);

    // SubRamo
    doc.setFont(undefined!, "bold");
    doc.text(`Sub-ramo:`, 10, currentY + 25);
    doc.setFont(undefined!, "normal");
    doc.text(`${slob ? slob : 'Todos'}`, 35, currentY + 25);

  };

  const body = data.map((record) => [
    record.policyNumber,
    record.policyEffectiveDate,
    record.expirationDate,
    `${record.clientCode} ${record.clientName}`,
    formatCurrency(record.insuredAmmount),
    formatCurrency(record.premium),
    formatCurrency(record.percentageCoinsurance),
    record.producerNumber,
    record.producerName,
    formatCurrency(record.percentageCommission),
    formatCurrency(record.balance),
    formatCurrency(record.pendingPercentage),
    record.facultative ? 'Sí' : 'No',
  ]);


  body.unshift([
    "Póliza",
    "Vigencia Inicio",
    "Vigencia Fin",
    "Asegurado",
    "Monto Asegurado",
    'Prima',
    '%Coas.',
    'Intermediario Código',
    'Intermediario Nombre',
    'Intermediario % Comisión',
    'Balance',
    '%Pend.',
    'Facul.',
  ]);

  const totalPrime = data.reduce((acc, cur) => cur.premium + acc, 0);
  const totalBalance = data.reduce((acc, cur) => cur.balance + acc, 0);
  body.push([
    "", "", "",
    `Total Pólizas:                  ${data.length}`,
    "Sub Total:",
    formatCurrency(totalPrime),
    "", "", "", "",
    formatCurrency(totalBalance),
    "", "",
  ]);

  body.push([
    "", "", "",
    `Total Gral. Pólizas:    ${data.length}`,
    "",
    `   ${formatCurrency(totalPrime)}`,
    "", "", "", "",
    `  ${formatCurrency(totalBalance)}`,
    "", "",
  ]);

  doc.autoTable({
    startY: currentY + 30,
    body,
    margin: { left: 10, top: currentY + 30 },
    headStyles: {
      fillColor: [0, 85, 140],
      textColor: [255, 255, 255],
      fontSize: 10,
      halign: "left",
    },
    styles: {
      fontSize: 8
    },
    columnStyles: {
      0: { halign: "left" },
      1: { halign: "left" },
      2: { halign: "left" },
      3: { halign: "left" },
      4: { halign: "right" },
      5: { halign: "right" },
      6: { halign: "right" },
      7: { halign: "right" },
      8: { halign: "right" },
      9: { halign: "right" },
      10: { halign: "right" },
      11: { halign: "right" },
      12: { halign: "right" },
    },
    didParseCell: (data: any) => {
      if (data.row.index === 0 && data.section === "body") {
        data.cell.styles.valign = 'bottom';
        data.cell.styles.lineWidth = { bottom: 1 };
        data.cell.styles.lineColor = [255, 165, 0];
        data.cell.styles.fillColor = [255, 255, 255];
        data.cell.styles.fontStyle = "bold";
      }
      if (data.row.index === data.table.body.length - 2 && data.section === "body") {
        data.cell.styles.valign = 'bottom';
        data.cell.styles.lineWidth = { bottom: 0.5 };
        data.cell.styles.lineColor = [0, 0, 0];
        data.cell.styles.fillColor = [255, 255, 255];
        data.cell.styles.fontStyle = "bold";
      }
      if (data.row.index === data.table.body.length - 1 && data.section === "body") {
        data.cell.styles.valign = 'bottom';
        data.cell.styles.fillColor = [255, 255, 255];
        data.cell.styles.fontStyle = "bold";
        data.cell.styles.fontSize = 9;
      }
    },

    didDrawPage: () => {
      pageHeader(doc); // Call the header function
    },
  });


  doc.save("Renovaciones.pdf");
};


const formatCurrency = (amout: number): string => {
  return new Intl.NumberFormat("es-DO", { minimumFractionDigits: 2, maximumFractionDigits: 2, }).format(amout)
}
